<template>
  <div class="finalizar-container bg-default">
    <v-row no-gutters justify="center" align="center" class="h-100">
      <v-col cols="10" sm="7" md="6" lg="5" class="text-center">
        <v-img src="@/assets/img-finalizado.png" max-width="200" class="mx-auto mb-4" />
        <h4 class="secondary-font">Informações enviadas com sucesso!</h4>
        <h4 class="secondary-font text--secondary mt-5">
          Questionário concluído com sucesso. Agradecemos por sua participação! Suas respostas foram enviadas com
          sucesso e serão tratadas com total sigilo. Elas são fundamentais para promover um ambiente de trabalho mais
          saudável, respeitoso e acolhedor. Cuidar da saúde mental é um ato de coragem e você acaba de dar um grande
          passo.
        </h4>
        <v-btn
          @click="onFinalizar"
          color="primary"
          class="secondary-font text-capitalize font-weight-black mt-10"
          elevation="24"
          rounded
        >
          Voltar à Pagina Inicial
          <v-icon right>mdi-arrow-right-bold-circle-outline</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  methods: {
    onFinalizar() {
      this.$store.commit('avaliacaoPsicossocial/RESET')
      this.$router.push({ name: 'dashboard' })
    }
  }
}
</script>

<style scoped>
.finalizar-container {
  min-height: calc(100vh - 64px);
  display: flex;
  flex-direction: column;
}

.h-100 {
  flex: 1;
}
</style>
